import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { SessionSearchResponse } from '@utils/types/back-office/session-inspector';

export const SESSION_INSPECTOR_SEARCH_KEY = 'session-inspector-search';

type SearchSessionsParams = {
  q?: string;
  org_id?: number;
  status?: string;
  error_category?: string;
  date_from?: string;
  date_to?: string;
  limit?: number;
  offset?: number;
};

export const useSearchSessions = (
  params: SearchSessionsParams,
  enabled = true
) => {
  const fetchSessions = async (): Promise<SessionSearchResponse> => {
    const searchParams = new URLSearchParams();
    if (params.q) searchParams.set('q', params.q);
    if (params.org_id) searchParams.set('org_id', String(params.org_id));
    if (params.status) searchParams.set('status', params.status);
    if (params.error_category)
      searchParams.set('error_category', params.error_category);
    if (params.date_from) searchParams.set('date_from', params.date_from);
    if (params.date_to) searchParams.set('date_to', params.date_to);
    searchParams.set('limit', String(params.limit ?? 25));
    searchParams.set('offset', String(params.offset ?? 0));

    const { data } = await Axios.get<SessionSearchResponse>(
      `/api/admin/session-inspector/search?${searchParams}`
    );
    return data;
  };

  return useQuery<SessionSearchResponse>(
    [SESSION_INSPECTOR_SEARCH_KEY, params],
    fetchSessions,
    {
      enabled: enabled && Boolean(params.q || params.org_id || params.status),
      staleTime: 10_000,
      refetchOnWindowFocus: false
    }
  );
};
